import { Component, OnInit, Input, ViewEncapsulation, OnDestroy } from '@angular/core';
import { Process } from '../../../../models/process-models';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { ProcessService } from '../../../../services/process.service';
import { SaveFormService } from '../../../../services/save-form.service';
import { SurveyService } from '../../../../services/survey.service';
import { NgxSelectOption } from 'ngx-select-ex';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { LocalizedSurvey } from '../../../../models/questions';

@Component({
  selector: 'app-process-general-info',
  templateUrl: './process-general-info.component.html',
  styleUrls: ['./process-general-info.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProcessGeneralInfoComponent implements OnInit, OnDestroy {

  @Input() process: Process;

  subscription: Subscription;
  surveys: Array<LocalizedSurvey>;
  surveyItems: Array<NgxSelectOption>;
  processGeneralInfoForm: FormGroup;
  partOfNameControl = 'name_';
  descriptionControlPrefix = 'description_';
  namePropertyArray: Array<string> = [];
  descriptions: Array<string> = [];
  descriptionPlaceholders: Array<string> = [];
  placeholderArray: Array<string> = [];
  surveySelectControl = new FormControl();
  minDate: Date;
  isToggle: boolean = true;


  constructor(private processGeneralInfoFormBuilder: FormBuilder,
    private formService: SaveFormService, private processService: ProcessService,
    private surveyService: SurveyService) {
    this.subscribeOnSave();
  }

  ngOnInit() {   
    this.getAllSurveys();
    this.setCalendarSettings();
    this.createProcessForm();
    this.setLocalizationNames();
    this.setPlaceholers();
    this.setSurvey(this.process.surveyId);    
  }

  setLocalizationNames() {
    this.formService.addAllLocalizedNameToFormGroup(this.processGeneralInfoForm,
      this.partOfNameControl, this.process.name);
    this.formService.addAllLocalizedNameToFormGroup(this.processGeneralInfoForm,
      this.descriptionControlPrefix, this.process.description);    
    this.namePropertyArray = this.formService.
      mapFormGroupControlToPropArray(this.processGeneralInfoForm, this.partOfNameControl);
    this.descriptions = this.formService.
      mapFormGroupControlToPropArray(this.processGeneralInfoForm, this.descriptionControlPrefix);
  }

  createProcessForm() {
    this.processGeneralInfoForm = this.processGeneralInfoFormBuilder.group({
      startDate: moment(this.process.firstDuration.startDate).toDate(),
      endDate: moment(this.process.firstDuration.endDate).toDate()
    });
  }

  getAllSurveys() {
    this.surveyService.getAll()
      .subscribe(x => {
        this.surveys = x;
        this.surveyItems = this.mapSurveyToNgSelect(this.surveys);
      });
  }

  ngOnDestroy() {
    if (!this.subscription) { return; }
    this.subscription.unsubscribe();
  }

  private mapSurveyToNgSelect(surveys: Array<LocalizedSurvey>): Array<NgxSelectOption> {
    return surveys.map(x => Object.assign({
      id: x.id,
      text: x.name
    }));
  }

  private setCalendarSettings() {
    if (!this.process.firstDuration) {
      this.process.firstDuration = {};
    }
    this.minDate = new Date();
  }

  private setSurvey(surveyId) {
    this.surveySelectControl.setValue(surveyId);
    this.surveySelectControl.valueChanges.subscribe(value => {
      const selectedSurveyIndex = this.surveys.findIndex(x => x.id === +value);
      if (selectedSurveyIndex === -1) {
        return;
      }
      this.process.surveyId = +value;
    });
  }

  private setPlaceholers() {
    const allControls = this.formService.getAllFormControlsFields(this.processGeneralInfoForm.controls);
    const nameControls = this.formService.getControlsByControlName(this.partOfNameControl, allControls);
    const descriptionControls = this.formService.getControlsByControlName(this.partOfNameControl, allControls);
    this.placeholderArray = this.formService.setPlaceholderArrayByPropName(nameControls,
      'Enter the name of the process in');
    this.descriptionPlaceholders = this.formService.setPlaceholderArrayByPropName(descriptionControls,
        'Enter the description of the process in');
  }

  private saveGeneralInfo() {
    this.process.name = this.formService.mapFormvalueToQuestion(this.processGeneralInfoForm.value, this.partOfNameControl);
    this.process.description = this.formService.mapFormvalueToQuestion(this.processGeneralInfoForm.value, this.descriptionControlPrefix);
    this.process.firstDuration.startDate = this.processService.convertDateToString(this.processGeneralInfoForm.value.startDate);
    this.process.firstDuration.endDate = this.processService.convertDateToString(this.processGeneralInfoForm.value.endDate);
  }

  private subscribeOnSave() {
    if (this.subscription) { return; }
    this.subscription = this.processService.saveProcessClicked$
      .subscribe(() => this.saveGeneralInfo());
  }
}
